import { isNullOrUndefined } from '@/utils/comparators'

/**
* Receives an Array and returns a filtered Array with only unique values
* @param {Array} array
*/
const unique = (array) => {
  if (isNullOrUndefined(array)) {
    return []
  }

  let unique = array.filter((elem, pos, arr) => {
    return arr.indexOf(elem) === pos
  })
  return unique
}

/**
* Receives an object and returns true if the object is an Array containing values
* @param {object} obj
*/
const isEmpty = (obj) => {
  if (isNullOrUndefined(obj)) {
    return true
  }
  if (!Array.isArray(obj)) {
    return true
  }
  return obj.length === 0
}

export {
  unique,
  isEmpty
}



// WEBPACK FOOTER //
// ./src/utils/array.js